function merge_objects(object1, object2) {
  object1 = object1 ? object1 : {};
  object2 = object2 ? object2 : {};
  return Object.assign({}, object1, object2);
}

export default function(store1, store2) {
  const store_module = {
    state: null,
    getters: null,
    mutations: null,
    actions: null,
  };
  for (let key in store_module) {
    store_module[key] = merge_objects(store1[key], store2[key]);
  }
  store_module.namespaced = true;
  return store_module;
}
